
document.addEventListener('page:loaded', function() {
/*============================================================================
  TOGGLE THE HOLIDAY BANNER TEXT ON ANNOUNCEMENT BAR, IF CHOSEN
==============================================================================*/
  // Get references to the link and the dropdown content
  const holidaydropdownLink = document.getElementById("holiday-dropdown-link");
  
  if (holidaydropdownLink) {
    const holidaydropdownContent = document.getElementById("holiday-dropdown-content");
  
    // Add a click event listener to the link
    holidaydropdownLink.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent the link from navigating
    
        // Toggle the display of the dropdown content
        if (holidaydropdownContent.style.display === "none") {
            holidaydropdownContent.style.display = "block";
        } else {
            holidaydropdownContent.style.display = "none";
        }
    });
  }

  
/*============================================================================
  HIDE BUNDLES SECTION AND LINKS ON B2B AND NAV MENU ITEM
==============================================================================*/

  //console.log(isWholesaleCustomer);
  if (isWholesaleCustomer) {
    // this is a wholesale customer

    // hide the menu item and all bundle links   
    setTimeout(function() {
      const menuParent = document.querySelector('ul.site-nav');
      //menuParent.children[3].style.display = 'none';

      //const bundle = menuParent.children[0].querySelector('ul.gm-grid a[href="/collections/bundles"]');
      //bundle.style.display = 'none';

      const pillowBundle = menuParent.children[0].querySelector('ul.mega-menu__column-links li a[href="/collections/pillow-bundles"]');
      pillowBundle.style.display = 'none';

      const beddingBundle = menuParent.children[1].querySelector('ul.mega-menu__column-links li a[href="/collections/bedding-bundles"]');
      beddingBundle.style.display = 'none';

      const bathBundle = menuParent.children[2].querySelector('ul.mega-menu__column-links li a[href="/collections/bath-bundles"]');
      bathBundle.style.display = 'none';

    }, 800);
    
    
    
  }

/*============================================================================
  GET THE LOGO WIDTH AND ADD TO A VARIABLE, FOR MEGA MENU
==============================================================================*/
  const logo = document.getElementsByClassName("site-header__logo");

  // Get the width of the div
  if (logo) {
    const logoWidth = logo[0].offsetWidth;

    // Set the value of a CSS variable
    document.documentElement.style.setProperty('--logo-width', `${logoWidth}px`);
  }


/*============================================================================
  GET THE SITE HEADER HEIGHT AND ADD TO A VARIABLE, SO THE MOBILE SLIDE NAV
  CAN START EXACTLY WHERE THE HEADER ENDS INSTEAD OF A HARDCODED PX VALUE
  (the header's real height varies with the announcement bar, font scaling,
  etc., so a fixed number drifts out of sync across mobile screen sizes)
==============================================================================*/
  function updateSiteHeaderHeight() {
    const siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;

    const announcement = document.querySelector('.announcement');
    const totalHeight = siteHeader.offsetHeight + (announcement ? announcement.offsetHeight : 0) - 5;

    document.documentElement.style.setProperty('--site-header-height', `${totalHeight}px`);
  }

  updateSiteHeaderHeight();

  let siteHeaderHeightResizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(siteHeaderHeightResizeTimeout);
    siteHeaderHeightResizeTimeout = setTimeout(updateSiteHeaderHeight, 150);
  });


/*============================================================================
  MAKE THE HEADER TRANSPARENT WHEN THE FIRST SECTION ON THE PAGE IS AN
  ANIMATED HERO — Liquid can't see what section comes after the header (each
  section renders independently), so this checks the actual rendered DOM
  instead of relying on a template-type checkbox like the index/collection
  overlay settings do.
==============================================================================*/
  (function () {
    var headerWrapper = document.querySelector('.header-wrapper');
    var siteHeader = document.querySelector('.site-header');
    var mainContent = document.getElementById('MainContent');
    if (!headerWrapper || !siteHeader || !mainContent) return;

    var firstSection = mainContent.querySelector(':scope > .shopify-section');
    if (!firstSection || !firstSection.querySelector('.hero-animated')) return;

    headerWrapper.classList.add('header-wrapper--overlay', 'is-light');
    siteHeader.setAttribute('data-overlay', 'true');
  })();


/*============================================================================
  PREVENT SCROLL ON MOBILE MENU OPEN
==============================================================================*/
  const button = document.querySelector('.js-toggle-slide-nav');
  
  button.addEventListener('click', function(event) {
    const htmlTag = document.querySelector('html');
    if (button.classList.contains('is-active')) {
      htmlTag.classList.add('modal-open');

      const findLinks = htmlTag.querySelectorAll('.secondary-mobile');
      if (findLinks.length < 1) { 
        addSecondary(); 
      }
    } else {
      htmlTag.classList.remove('modal-open');
    }
    
  });

/*============================================================================
  ADD SECONDARY NAV TO THE BOTTOM OF MOBILE MENU
==============================================================================*/
 /* function addSecondary() {
    // Find the div element
    const divElement = document.querySelector('li.gm-item.gm-level-0.gm-theme-li');
    
    // Create the link elements
    const link1 = document.createElement('a');
    if (isWholesaleCustomer) {
      link1.href = '/pages/trade#shopify-section-template--19765623259452__ed0ce700-af5e-4b67-99fa-89859de633d5';
    } else {
      link1.href = '/pages/faqs';
    }
    
    link1.textContent = 'FAQ';
    link1.classList.add('secondary-mobile');
  
    
    const link2 = document.createElement('a');
    link2.href = '/pages/swym-wishlist';
    link2.textContent = 'Wishlist';
    link2.classList.add('secondary-mobile');
  
  
    const link3 = document.createElement('a');
    link3.href = '/pages/guides';
    link3.textContent = 'Guides';
    link3.classList.add('secondary-mobile');

    const link4 = document.createElement('a');
    link4.href = '/pages/wholesale-assets';
    link4.textContent = 'Wholesale Resources';
    link4.classList.add('secondary-mobile');
  
    if (isWholesaleCustomer) {
       // Prepend the link elements to the div
      divElement.prepend(link1, link2, link3, link4);
    } else {
       // Prepend the link elements to the div
      divElement.prepend(link1, link2, link3);
    }
   
  
    // replace log in with icon
    var login_link = document.querySelector('.slide-nav__link.gm-target.js-no-transition');
  
    // Create the image element
    const imgElement = document.createElement('img');
    imgElement.src = '//thepillowbar.com/cdn/shop/t/14/assets/account_35x35.png?v=81600534233459846981785952911';
    imgElement.alt = 'Account Icon';
  
    login_link.removeChild(login_link.firstChild);
    login_link.appendChild(imgElement);
  } 
    */
  
/*============================================================================
  HIDE CATEGORY FILTER ON SUBCOLLECTION PAGES
==============================================================================*/
  
  // Get the current template name from the URL path
  var currentTemplate = theme.template;
  
  // Compare the current template name and hide the div if it matches the desired text
  if (currentTemplate === 'collection.sub-collection-landing') {
    var divElement = document.getElementById('CollectionFiltersSection');
    if (divElement) {
      divElement.style.display = 'none';
    }
   
  }

 
/*============================================================================
  ADD TOGGLE TO CATEGORY FILTER HEADER ON MAIN CATEGORY PAGES
==============================================================================*/
  // Get all the accordion title elements
  var accordionTitles = document.getElementsByClassName('collection-filter__title');

  // Attach a click event listener to each title
  for (var i = 0; i < accordionTitles.length; i++) {
    accordionTitles[i].addEventListener('click', function() {
      // Toggle the display of the accordion content
      this.nextElementSibling.style.display =
        this.nextElementSibling.style.display === 'none' ? 'block' : 'none';

      // Toggle the 'open' class to the accordion item
      this.parentNode.classList.toggle('open');
    });
  }
  
/*============================================================================
  EMBROIDERY GUIDE PAGE
==============================================================================*/
  // Check if the current page URL contains 'embroidery-guide'
  if (window.location.href.includes('embroidery-guide')) {
    // The user is on a page with 'embroidery-guide' in the URL

    const styles = document.querySelector('.main-content .shopify-section:nth-child(2)');
    //styles.style.display = 'none';

    const colors = document.querySelector('.main-content .shopify-section:nth-child(3)');
    colors.style.display = 'none';

    const guides = document.querySelectorAll('.main-content .shopify-section:nth-child(4), .main-content .shopify-section:nth-child(5), .main-content .shopify-section:nth-child(6), .main-content .shopify-section:nth-child(7)');
    guides.forEach(guide => {
      guide.style.display = 'none';
    });
      
    const styleLink = document.getElementById("monogram-styles-tab");
    styleLink.addEventListener("click", showTab);

    const colorLink = document.getElementById("embroidery-colors-tab");
    colorLink.addEventListener("click", showTab);

    const guideLink = document.getElementById("monogram-guide-tab");
    guideLink.addEventListener("click", showTab);
  

    // JavaScript for tab sshowing/hiding CONTENT
    function showTab() {
      event.preventDefault();

      const linkClicked = event.target.id;
    
      // Show the style tab content
      const content_style = document.querySelector('.main-content .shopify-section:nth-child(2)');
      const content_color = document.querySelector('.main-content .shopify-section:nth-child(3)');
      const content_guides = document.querySelectorAll('.main-content .shopify-section:nth-child(4), .main-content .shopify-section:nth-child(5), .main-content .shopify-section:nth-child(6), .main-content .shopify-section:nth-child(7)');

      const styleLink = document.getElementById("monogram-styles-tab");
      const colorLink = document.getElementById("embroidery-colors-tab");
      const guideLink = document.getElementById("monogram-guide-tab");
      styleLink.classList.remove("active");
      colorLink.classList.remove("active");
      guideLink.classList.remove("active");
    
      // If the third tab is chosen, show the last four divs
      if (linkClicked == "monogram-guide-tab") {
        content_style.style.display = 'none';
        content_color.style.display = 'none';
        content_guides.forEach(guide => {
          guide.style.display = 'block';
        });
        guideLink.classList.add("active");
      } else if (linkClicked == 'embroidery-colors-tab') {
        content_color.style.display = 'block';
        colorLink.classList.add("active");
        content_style.style.display = 'none';
        content_guides.forEach(guide => {
          guide.style.display = 'none';
        });
      } else if (linkClicked == 'monogram-styles-tab') {
        content_style.style.display = 'block';
        styleLink.classList.add("active");
        content_color.style.display = 'none';
        content_guides.forEach(guide => {
          guide.style.display = 'none';
        });
      }
    }
  
  } 

/*============================================================================
 WHOLESALE APPLICATION PAGE IFRAME STYLE
==============================================================================*/
  // Check if the current page URL contains 'embroidery-guide'
  if (window.location.href.includes('wholesale-application-form')) {

    setTimeout(changeiFrame, 5000);

    function changeiFrame() {
    
       const iframe = document.querySelector(".airtable-embed");
  
    
      // Wait for the iframe to load its content
        //iframe.addEventListener("load", function () {
          // Access the iframe's document
          const iframeDoc = iframe.contentWindow.document;
        
          // Modify the CSS within the iframe
          const iframeElement = iframeDoc.querySelector(".formHeader");
          if (iframeElement) {
            // Change the CSS properties of the element within the iframe
            iframeElement.style.display = "none";
          }
        //});
    }
  }
});


/*============================================================================
  SLICK SLIDER - QUOTES CAROUSEL
==============================================================================*/

function loadScripts(callback) {
  // Load jQuery
  var jQueryScript = document.createElement('script');
  jQueryScript.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
  jQueryScript.onload = function() {
    // jQuery has finished loading
    // Load Slick carousel library
    var slickScript = document.createElement('script');
    slickScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
    slickScript.onload = callback; // Execute the callback function once Slick carousel library has finished loading
    document.head.appendChild(slickScript);
  };
 
  document.head.appendChild(jQueryScript);
}


loadScripts(function() {
  // Both jQuery and Slick carousel library have finished loading
  // Your code using jQuery and Slick here
  $('.slider-nav').slick({
    // Slick carousel initialization options
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: true
  });

  $('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.slider-nav').slick('slickGoTo', slideno - 1);

    // Show all white images
    $('.action img:not(.hover_img)').show();
    // Hide all hover images
    $('.action img.hover_img').hide();

    // hide the white image
    $(this).find('img:not(.hover_img)').hide();
    // Show the image with class 'hover_img'
    $(this).find('.hover_img').show();
 });
  

});


















  